import React, { useEffect, useState } from "react";
import { db, ref, onValue } from "./firebase"; // Import the db object
import "./App.css";
import SessionHeader from "./components/SessionHeader";
import DriverItem from "./components/DriverItem";

// Function to convert a time string (HH:MM:SS) to seconds
function timeStringToSeconds(timeStr) {
  if (timeStr) {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    return totalSeconds.toFixed(3); // Rounds to three decimal places
  }
  return ""; // Handle the case when timeStr is not provided
}

const DataDisplay = () => {
  const [competitors, setCompetitors] = useState([]);
  const [sortBy, setSortBy] = useState('position')
  const [bestLapTime, setBestLapTime] = useState(""); // Store the best lap time
  const [isCompetitorsDataNull, setIsCompetitorsDataNull] = useState(true); // Initialize to true


  useEffect(() => {
    const competitorsRef = ref(db, "DemoDB/competitor");

    const onDataChange = (snapshot) => {
      const competitorsData = [];
      let bestTime = Infinity; // Initialize with a large value
      snapshot.forEach((childSnapshot) => {
        const competitorData = childSnapshot.val();
        competitorsData.push(competitorData);
        if (parseFloat(timeStringToSeconds(competitorData.best_lap_time)) < bestTime) {
          bestTime = parseFloat(timeStringToSeconds(competitorData.best_lap_time));
        }
      });

      setBestLapTime(bestTime)
      setCompetitors(competitorsData);
      setIsCompetitorsDataNull(competitorsData === null || competitorsData.length === 0);
    };

    const unsubscribe = onValue(competitorsRef, onDataChange);
    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, []);

  const toggleSortOrder = () => {
    console.log('Clicked')
    setSortBy((prevSortBy) =>
      prevSortBy === "position" ? "best_time" : "position"
    );
  };

  competitors.sort((a, b) => {
    if (sortBy === 'position') {
      return a.position - b.position;
    }
    if (sortBy === 'best_time') {
      return timeStringToSeconds(a.best_lap_time) - timeStringToSeconds(b.best_lap_time)
    }
    return ""
  });


  return (
    <div>
      {!isCompetitorsDataNull ?
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '20px', marginBottom: '20px' }}>
          <SessionHeader toggleSortOrder={toggleSortOrder} sortBy={sortBy} />
          {competitors.map((competitor, index) => (
            <DriverItem
              key={index}
              position={competitor.position}
              number={competitor.number}
              first_name={competitor.first_name}
              last_name={competitor.last_name}
              difference={sortBy === 'position' ? timeStringToSeconds(competitor.difference) : (parseFloat(timeStringToSeconds(competitor.best_lap_time)) - bestLapTime).toFixed(3)}
              last_lap_time={competitor.last_lap_time}
              lap={competitor.lap}
              best_lap={competitor.best_lap}
              best_time={competitor.best_lap_time}
            />
          ))}
        </div>
        :
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '20px', marginBottom: '20px' }}>
          <p>No current race or not receiving data....</p>
        </div>
      }
    </div>
  );
};

export default DataDisplay;
